var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 5.71875C0 5.875 0 6.09375 0.15625 6.25L4.71875 10.875C4.875 11.0312 5.125 11.0312 5.25 10.875L5.875 10.25C6.03125 10.125 6.03125 9.875 5.875 9.71875L2.1875 6 5.875 2.25C6.03125 2.09375 6.03125 1.875 5.875 1.71875L5.25 1.09375C5.125 0.9375 4.875 0.9375 4.71875 1.09375L0.15625 5.71875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.538d73d9.svg";
export { ForwardRef as ReactComponent };